import { Routes } from '@angular/router';
import { LoginComponent } from './modules/login/login/login.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { LandingPageComponent } from './modules/landing/landing-page/landing-page.component';
import { CreateRegistrationComponent } from './modules/clientRegistration/create-registration/create-registration.component';
import { SignupComponent } from './modules/signup/signup/signup.component';
import { ReSetPasswordComponent } from './modules/signup/reset-password/reset-password.component';
import { ClientPaymentComponent } from './modules/clientPayment/client-payment/client-payment.component';
import { OtpPageComponent } from './modules/signup/otp-page/otp-page.component';
import { authGuard } from './core/guard/auth.guard';
import { CatalogueViewComponent } from './modules/product-catalogue/catalogue-view/catalogue-view.component';
import { CartComponent } from './modules/product-catalogue/cart/cart.component';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './modules/change-password/change-password.component';
import { ExcelUploadComponent } from './modules/product-catalogue/excel-upload/excel-upload.component';
import { WebFormComponent } from './modules/product-catalogue/web-form/web-form.component';
import { forgotPassword } from './core/models/forgot-password';
import { OrderSuccessComponent } from './modules/product-catalogue/order-success/order-success.component';
import { ThankYouPageComponent } from './modules/thank-you-page/thank-you-page.component';


export const routes: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
        title: 'Login'
    },
    {
        path: 'signup',
        component: SignupComponent
    },
    {
        path: 'reset-password',
        component: ReSetPasswordComponent,
        canActivate: [authGuard],
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {

        path: 'change-password',
        component: ChangePasswordComponent,
        // canActivate: [authGuard],
        // children: [
        //     {
        //         path: '',
        //         component: ChangePasswordComponent,
        //         runGuardsAndResolvers: 'always',
        //         resolve: {
        //             userid: 'useridResolver'
        //         }
        //     }
        // ]


    }
    ,
    {
        path: 'forgot-password',
        component: ForgotPasswordComponent,

    },
    {
        path: 'otp-page',
        component: OtpPageComponent,
        canActivate: [authGuard],
    },
    {
        path: 'create-registration',
        component: CreateRegistrationComponent,
        title: 'Registration Page'
      
    },
    {
        path: 'thank-you',
        component: ThankYouPageComponent,
        title: 'Edenred Global Rewards Portal',

    },
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: 'landing',
                component: LandingPageComponent,
                title: 'Edenred Global Rewards Portal',
                // canActivate: [authGuard],

            },

            {
                path: 'client-payment',
                component: ClientPaymentComponent,
                title: 'Edenred Global Rewards Portal',
                canActivate: [authGuard],
            },
            {
                path: 'catalogue-view',
                component: CatalogueViewComponent,
                title: 'Edenred Global Rewards Portal',
                // canActivate: [authGuard],
            },
            {
                path: 'cart',
                component: CartComponent,
                title: 'Edenred Global Rewards Portal',
                // canActivate: [authGuard],
            },
            {
                path: 'excel-upload',
                component: ExcelUploadComponent,
                title: 'Edenred Global Rewards Portal',
                canActivate: [authGuard],
            },
            {
                path: 'web-form',
                component: WebFormComponent,
                title: 'Edenred Global Rewards Portal',
                canActivate: [authGuard],
            },
            {
                path: 'order-placed',
                component: OrderSuccessComponent,
                title: 'Edenred Global Rewards Portal',
                canActivate: [authGuard],
            },
            {
                path: '',
                redirectTo: '/signup', pathMatch: 'full'
            }

        ]
    }
];
